/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-30 18:57:40
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {AlarmQueryDOI} from "./api/alarmQueryApi";
import AlarmQueryService from "./service/alarmQueryService";
import './alarmQuery.less';
import { createNamespace } from 'src/util/bem';

@Component({name: 'alarm-query'})
export default class AlarmQuery extends BasicSearchPage<AlarmQueryService, AlarmQueryDOI.RowDataI, AlarmQueryDOI.QueryRowDataParamsI> {
    className=createNamespace('alarm-query')
    // checkBoxShow = true;

    @override
    renderHead(h) {
        return <div></div>
    }

	@override
	loadService () {
		this.service = new AlarmQueryService(this)
	}
}
